import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Accounting module landing page.
 *
 * Owner (2026-10-05): the department pages show MODULES, one card per module, the same
 * cards as General SS White (DeptLandingSections); a card shows only when the person may
 * open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * The route is gated by dept.accounting in allRoutes.js.
 */
const MODULES = ["epo", "travel", "cr", "tasks", "kpi"];

const Accounting = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-bank-line"
                        eyebrow="Finance"
                        title="Accounting"
                        subtitle="Ledger, billing, and financial reporting"
                        tone="default"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Accounting" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="accounting" title="Accounting modules" icon="ri-bank-line" />

                    <ComingSoonCard
                        compact
                        icon="ri-bank-line"
                        title="More for Accounting later"
                        message="Ideas for later: invoice and AR/AP tracking and month-end checklists. The modules above are live today."
                        tone="primary"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Accounting;
